import React, {useEffect, useState} from "react";
import api from "../services/api";
import "../styles/ProjectModal.css";
import { useToast } from '../context/UIContext';

export default function ProjectModal({project, onClose, onSave}) {
    const toast = useToast();
    const [customers, setCustomers] = useState([]);
    const [form, setForm] = useState({
        id: null,
        name: "",
        description: "",
        customerId: "",
    });

    useEffect(() => {
        api.get("/Company").then((res) => setCustomers(res.data));

        if (project) {
            setForm({
                ...project,
                customerId: project.customerId ?? project.companyID ?? project.companyId ?? "",
            });
        } else {
            setForm({
                id: null,
                name: "",
                description: "",
                customerId: "",
            });
        }
    }, [project]);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm((prev) => ({...prev, [name]: value}));
    };

    const handleSubmit = () => {
        if (!form.name || !form.description || !form.customerId) {
            toast("Bitte alle Felder ausfüllen");
            return;
        }

        if (form.id) {
            api
                .patch(`/Project/${form.id}`, {
                    name: form.name,
                    description: form.description,
                    company_id: form.customerId,
                })
                .then(onSave)
                .catch(err => toast(err.response?.data?.detail ?? 'Fehler beim Speichern'));
        } else {
            api
                .post("/Project", {
                    name: form.name,
                    description: form.description,
                    company_id: form.customerId,
                })
                .then(onSave)
                .catch(err => toast(err.response?.data?.detail ?? 'Fehler beim Speichern'));
        }
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>{form.id ? "Projekt anpassen" : "Projekt hinzufügen"}</h3>

                <input
                    name="name"
                    placeholder="Name"
                    value={form.name}
                    onChange={handleChange}
                    className="input"
                />

                <input
                    name="description"
                    placeholder="Beschreibung"
                    value={form.description}
                    onChange={handleChange}
                    className="input"
                />

                <select
                    name="customerId"
                    value={form.customerId}
                    onChange={handleChange}
                    className="input"
                >
                    <option value="">Kunde auswählen</option>
                    {customers.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>

                <div style={{marginTop: "15px"}}>
                    <button className="button-normal" onClick={handleSubmit}>
                        Speichern
                    </button>
                    <button className="button-danger" onClick={onClose}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
}